module.exports = __webpack_public_path__ + "static/media/logo-fc-analise.0d31fc6b.png";